import React, { FC } from "react";
import { Route } from "react-router-dom";

export const CustomRoute: FC<{
  isPrivate?: boolean;
  group?: number;
  role?: number;
  exact: boolean;
  path: string;
  component?: React.FC<{}>;
}> = ({ ...props }) => {
  return <Route {...props} />;
};
